<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <step-progress
          :steps="mySteps"
          :current-step="currentStep"
          icon-class="fa fa-check"
          active-color="#1E1040"
          passive-color="#b6abd3"
          :active-thickness="3"
          :passive-thickness="3"
          :line-thickness="5"
          class="px-4"
        ></step-progress>
        <!-- ================================================= Step Emitird ================================================= -->
        <div v-if="currentStep==0">
          <h6 class="mt-1 text-addiuva">Completa la información</h6>
          <hr class="horizontal dark" />
          <div class="row">
            <div class="col-md-3">
              <label class="form-control-label">Periodicidad <span class="text-danger">*</span></label>
              <vue-select
                :options="periodicidadOptions"
                label="text"
                v-model="periodicidad"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Fecha Inicio</label>
              <datepicker
                v-model="vigencia.inicio"
                :="basicConfigDatePicker"
                v-bind:disabled="true"
                name="fecha_inicio"
                class="datepicker-readonly"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Fecha Fin</label>
              <datepicker
                v-model="vigencia.fin"
                :="basicConfigDatePicker"
                v-bind:disabled="true"
                name="fecha_fin"
                class="datepicker-readonly"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Cantidad <span class="text-danger">*</span></label>
              <vue-select
                :options="cantidadsOptions"
                label="text"
                v-model="cantidad"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-3">
              <label class="form-control-label">
                <span v-if="cantidad==1">Fecha de Nacimiento <span class="text-danger">*</span></span>
                <span v-if="cantidad>1">Fechas de Nacimientos <span class="text-danger">*</span></span>
              </label
              >
              <!-- begin v-for nacimientos -->
              <div v-for="n in cantidad" :key="n" class="pb-2">
                <datepicker
                  v-model="nacimientos[n]"
                  :="basicConfigDatePicker"
                  :name="String(n)"
                ></datepicker>
              </div>
              <!-- end v-for -->
            </div>
          </div>
          <div class="row" v-if="validaPeticionPrograma">
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Programa  <span class="text-danger">*</span></label>
              <vue-select
                :options="programasOptions"
                label="text"
                v-model="programa"
                :reduce="(option) => option.value"
              ></vue-select>
              <label class="form-control-label">Tarifa</label>
              <InputGroup>
                  <InputText v-model="tarifa" type="text" disabled="disabled" />
                  <InputGroupAddon>
                      <small>x persona</small>
                  </InputGroupAddon>
              </InputGroup>
            </div>
            <div class="col-md-9">
              <div class="row p-3">
                <Toast/>
                <div v-if="this.programaDetalle != null">
                  <div class="col-12 bg-addiuva" style="border-radius: 5px;">
                    <h6 class="mt-1 p-2 text-white text-center">{{programaDetalle.programa}}</h6>
                  </div>
                  <div v-for="n in programaDetalle.beneficios" :key="n" class="">
                    <div class="row" v-if="programaDetalle.detalle_beneficio_columnas==2">
                      <div class="col-8 bg-addiuva-dark" style="">
                        <h6 class="p-2 text-white">{{n.beneficio}}</h6>
                      </div>
                      <div class="col-2 bg-addiuva-dark" style="">
                        <h6 class="p-2 text-white">{{programaDetalle.detalle_columna1}}</h6>
                      </div>
                      <div class="col-2 bg-addiuva-dark" style="">
                        <h6 class="p-2 text-white">{{programaDetalle.detalle_columna2}}</h6>
                      </div>
                    </div>
                    <div v-if="programaDetalle.detalle_beneficio_columnas==2">
                      <div v-for="c in n.coberturas" :key="c" class="row" style="border-bottom:1px #b4b4b4 solid;">
                        <div class="col-md-8 bg-addiuva">
                          <label class="p-1 font-weight-bold text-white">{{c.cobertura}}</label>
                        </div>
                        <div class="col-md-2">
                          <label class="p-1 font-weight-bold">{{c.detalle_columna1}}</label>
                        </div>
                        <div class="col-md-2">
                          <label class="p-1 font-weight-bold">{{c.detalle_columna2}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="programaDetalle.detalle_beneficio_columnas==1">
                      <div class="col-8 bg-addiuva-dark" style="">
                        <h6 class="p-2 text-white">{{n.beneficio}}</h6>
                      </div>
                      <div class="col-4 bg-addiuva-dark" style="">
                        <h6 class="p-2 text-white">{{programaDetalle.detalle_columna1}}</h6>
                      </div>
                    </div>

                    <div v-if="programaDetalle.detalle_beneficio_columnas==1">
                      <div v-for="c in n.coberturas" :key="c" class="row" style="border-bottom:1px #b4b4b4 solid;">
                        <div class="col-md-8 bg-addiuva">
                          <label class="p-1 text-white font-weight-bold">{{c.cobertura}}</label>
                        </div>
                        <div class="col-md-4">
                          <label class="p-1 font-weight-bold">{{c.detalle_columna1}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-6"></div>
            <div class="col-md-6 d-flex justify-content-end">
              <!-- <a class="btn btn-addiuva" @click="currentStep++" v-if="cotizacionValidada"> -->
              <a class="btn btn-addiuva" @click="currentStep++">
                Continuar &nbsp;<i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- ================================================= Step Registrar Afiliados ================================================= -->
        <div v-if="currentStep==1">
          <div class="row">
            <div class="col-12">
              <h6 class="mt-1 text-addiuva">Datos de los Afiliados</h6>
              <hr class="horizontal dark" />
              <div class="row">
                <div class="col-md-1 text-right" style="width: 4rem;"><label class="form-control-label">Nro</label></div>
                <div class="col-md-2"><label class="form-control-label">Nombres <span class="text-danger">*</span></label></div>
                <div class="col-md-2"><label class="form-control-label">Apellidos <span class="text-danger">*</span></label></div>
                <div class="col-md-1"><label class="form-control-label">Edad</label></div>
                <div class="col-md-2"><label class="form-control-label">Documento <span class="text-danger">*</span></label></div>
                <div class="col-md-2"><label class="form-control-label">Teléfono <span class="text-danger">*</span></label></div>
                <div class="col-md-2"><label class="form-control-label">Email <span class="text-danger">*</span></label></div>
              </div>
              <div v-for="n in cantidad" :key="n" class="pb-2">
                <div class="row" style="    border-top: 1px solid rgb(155 110 255 / 8%); padding-top: 1rem;">
                  <div class="col-md-1 text-right" style="width: 4rem;"><label class="form-control-label">{{n}}</label></div>
                  <div class="col-md-2">
                    <InputText v-model="nombres[n]" type="text" class="form-control"/>
                    <InlineMessage severity="error" v-if="this.errorNombres[n] == true" class="text-14px">Campo requerido</InlineMessage>
                  </div>
                  <div class="col-md-2">
                    <InputText type="text" v-model="apellidos[n]" class="form-control"/>
                    <InlineMessage severity="error" v-if="this.errorApellidos[n] == true" class="text-14px">Campo requerido</InlineMessage>
                  </div>
                  <div class="col-md-1">
                    <div class="bg-addiuva text-white" style="border-radius:0.5rem; padding: 0.5rem 0.75rem; user-select:none;">
                      {{edades[n]}}
                    </div>
                  </div>
                  <div class="col-md-2">
                    <InputText v-model="documentos[n]" type="text" class="form-control"/>
                    <InlineMessage severity="error" v-if="this.errorDocumentos[n] == true" class="text-14px">Campo requerido</InlineMessage>
                  </div>
                  <div class="col-md-2">
                    <InputNumber v-model="telefonos[n]" :useGrouping="false" class="w-100"/>
                    <InlineMessage severity="error" v-if="this.errorTelefonos[n] != false" class="text-14px">{{ this.errorTelefonos[n] }}</InlineMessage>
                  </div>
                  <div class="col-md-2">
                    <InputText v-model="emails[n]" type="email" class="form-control"/>
                    <InlineMessage severity="error" v-if="this.errorEmails[n] != false" class="text-14px">{{ this.errorEmails[n] }}</InlineMessage>
                  </div>
                </div>
                <div class="row" v-if="generarCodigoCertificado == false">
                  <div class="col-md-1" style="width: 4rem;"></div>
                  <div class="col-md-2"><label class="form-control-label">Código Certificado <span class="text-danger">*</span></label></div>
                </div>
                <div class="row" v-if="generarCodigoCertificado == false">
                  <div class="col-md-1" style="width: 4rem;"></div>
                  <div class="col-md-2">
                    <InputGroup>
                        <InputGroupAddon>
                            <small style="font-size:70%; font-weight: bold;">ADDBOL-</small>
                        </InputGroupAddon>
                        <InputText v-model="codigosCertificados[n]" type="text"/>
                    </InputGroup>
                    <InlineMessage severity="error" v-if="this.errorCodigos[n] == true" class="text-14px">Campo requerido</InlineMessage>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">
              <a class="btn" @click="currentStep--">
                <i class="fas fa-arrow-left"></i> &nbsp; Atrás
              </a>
            </div>
            <div class="col-md-6 d-flex justify-content-end">
              <a class="btn btn-addiuva" @click="currentStep++" v-if="registroValido">
                Continuar &nbsp;<i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- ================================================= Step Terminos y Condiciones, Forma de Pago ================================================= -->
        <div v-if="currentStep==2">
          <div class="row">
            <div class="col-12">
              <h6 class="mt-1 text-addiuva">Finalizar Registro</h6>
              <hr class="horizontal dark" />
              <h6>Términos y Condiciones</h6>
              <argon-checkbox id="flexCheckDefault" v-model="terminosCheck">
                <label class="form-check-label" for="flexCheckDefault">
                  Declaro que he leído y acepto expresamente las
                  <a
                    href="#" target="_black"
                    class="text-addiuva font-weight-bolder"
                  >Condiciones Generales</a>
                  aquí publicadas y que son aplicables a mi compra
                </label>
              </argon-checkbox>
              <h6>Tipo de Pago</h6>
              <div class="row">
                <div class="col-3"></div>
                <div class="d-flex col-3">
                  <RadioButton v-model="formaPago" inputId="formaPago1" name="formaPago" value="Tarjeta de Crédito/Débito" />
                  <label for="formaPago1" style="cursor:pointer; font-weight:400; font-size:0.875rem;">Tarjeta de Crédito/Débito</label>
                </div>
                <div class="d-flex col-3">
                  <RadioButton v-model="formaPago" inputId="formaPago2" name="formaPago" value="Efectivo" />
                  <label for="formaPago2" style="cursor:pointer; font-weight:400; font-size:0.875rem;">Efectivo</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">
              <a class="btn" @click="currentStep--">
                <i class="fas fa-arrow-left"></i> &nbsp; Atrás
              </a>
            </div>
            <div class="col-md-6 d-flex justify-content-end">
              <Button class="btn btn-addiuva" style="display: flex;"
                label="Comprar"
                icon="fas fa-arrow-right"
                iconPos="right"
                :loading="loadingButton"
                v-if="compraValida"
                @click="guardarRegistro" />
            </div>
          </div>
        </div>
      </div>
      </div>

    </div>
</template>

<script>
import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
import RadioButton from 'primevue/radiobutton';
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Datepicker from 'vuejs3-datepicker';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import InlineMessage from 'primevue/inlinemessage';
import Toast from 'primevue/toast';
import Button from 'primevue/button';
import axios from 'axios';
import authHeader from '../services/auth-header';

export default {
  name: "Afiliaciones",
  components: {
    VueSelect,
    ArgonCheckbox,
    RadioButton,
    Datepicker,
    StepProgress,
    InputText,
    InputNumber,
    InputGroup,
    InputGroupAddon,
    Button,
    InlineMessage,
    Toast
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      programa: null,
      programasOptions: [],
      allProgramas: [],
      tarifa: null,
      generarCodigoCertificado: null,
      periodicidad: null,
      periodicidadOptions: [],
      programaDetalle: null,
      cantidad: null,
      codigosCertificados: {},
      nombres: {},
      apellidos: {},
      nacimientos:{},
      documentos: {},
      telefonos: {},
      emails: {},
      cantidadsOptions: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5', value: 5 },
        { text: '6', value: 6 },
        { text: '7', value: 7 },
        { text: '8', value: 8 },
        { text: '9', value: 9 },
        { text: '10', value: 10 },
      ],
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      vigencia: {
        inicio: new Date().toJSON().slice(0, 10),
        fin: null
      },
      inicio: "1988-04-14",
      mySteps: ['Seleccionar Programa', 'Registrar Afiliados', 'Finalizar Registro', 'Generación de Certificados'],
      currentStep: 0,
      formaPago: "Efectivo",
      terminosCheck: null,
      errorNombres: [],
      errorApellidos: [],
      errorDocumentos: [],
      errorTelefonos: [],
      errorEmails: [],
      errorCodigos: [],
      loadingButton: false
      // regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  methods: {
    formatDate: function (date) {
      let aDate = date.split('-');
      return new Date(aDate[0], parseInt(aDate[1])-1, aDate[2]);
    },
    calculateAge: function (nacimiento) {
      let dob = new Date(nacimiento);
      //calculate month difference from current date in time
      let month_diff = Date.now() - dob.getTime();
      //convert the calculated difference in date format
      let age_dt = new Date(month_diff);
      //extract year from date
      let year = age_dt.getUTCFullYear();
      //now calculate the age of the user
      let age = Math.abs(year - 1970);
      return age;
    },
    valueIsValid: function(value) {
      return (value !== null && value !== "" && value !== 0 && value !== [] && (typeof value !== "undefined"));
    },
    isEmailValid: function(email) {
      let validationRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;
      return validationRegex.test(email)
    },
    isPhoneNumberValid: function(phoneNumber) {
      let validationRegex = /^\d{8,}$/;
      return validationRegex.test(phoneNumber);
    },
    guardarRegistro: function() {
      //Prepare Data to Send
      const programSelected = this.allProgramas.find(({ id_programa }) => id_programa === this.programa);
      let aAfiliados = [];
      this.afiliados.forEach(afiliado => {
        aAfiliados.push({
          "codigo_certificado": afiliado.codigoCertificado ? "ADDBOL-"+afiliado.codigoCertificado : '',
          "nombres": afiliado.nombres,
          "apellidos": afiliado.apellidos,
          "edad": afiliado.edad,
          "fecha_nacimiento": this.changeIsoToDate(afiliado.dob),
          "numero_documento": afiliado.documento,
          "telefono": afiliado.telefono.toString(),
          "email": afiliado.email,
        })
      })
      let payload = {
        "id_programa_periodo_tarifa": programSelected.id_programa_periodo_tarifa,
        "id_agencia": 1,
        "fecha_inicio": this.vigencia.inicio,
        "fecha_fin": this.vigencia.fin,
        "tarifa": this.tarifa,
        "afiliados": aAfiliados,
        "terminos_condiciones": this.terminosCheck,
        "metodo_pago": this.formaPago,
      }
      this.loadingButton = true;
      // Send Data by Axios
      let url = this.API_URL + "/afiliaciones";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        this.loadingButton = false;
        if (response.data.status) {
            let code_afiliacion = response.data.data.code_afiliacion;
            this.$router.push({
                name: 'Afiliación Addiuva',
                params: { id: code_afiliacion }
            });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getPeriodos: function() {
      let url = this.API_URL + "/periodos/lista";
      axios
        ({
          url: url,
          method: 'post',
          data: {"activado": true},
          headers: authHeader(),
        })
        .then(response => {
          if (response.data.status) {
            let periodos = [];
            response.data.data.forEach(element => {
              periodos.push({ text: element.nombre, value: element.id_periodo, meses_cubiertos: element.meses_cubiertos });
            });
            this.periodicidadOptions = periodos
          }
        })
        .catch(error => {
          console.log("Error: " + error.response.data);
        });
    },
    getProgramas: function() {
      let url = this.API_URL + "/programas/edad";
      let payload = {
        edades: Object.values(this.edades),
        id_periodo: this.periodicidad
      };
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
        .then(response => {
          if (response.data.status) {
            let programas = [];
            response.data.data.forEach(element => {
              programas.push({
                text: element.nombre,
                value: element.id_programa,
                cantidad_max_personas: element.cantidad_maxima_personas,
                descripcion: element.descripcion});
            });
            this.allProgramas = response.data.data;
            this.programasOptions = programas
            this.programa = null;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        });
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    getBeneficioCobertura: function () {
      if (this.programa != null && this.periodicidad != null) {
        let url = this.API_URL + "/ppts/seleccion?id_programa=" + this.programa + "&id_periodo=" + this.periodicidad;
        axios({
          url: url,
          method: 'get',
          headers: authHeader(),
        })
        .then(response => {
          this.programaDetalle = null;
          if (response.data.status) {
            this.programaDetalle = response.data.data;
          } else {
            this.$toast.add({ severity: 'error', summary: 'Programa Detalle', detail: response.data.message, life: 3000});
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      } else {
        this.programaDetalle = null;
      }
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Dashboard'});
      }
    }
  },
  computed: {
    user() {
      let aDate = this.inicio.split('-');
      return new Date(aDate[0], parseInt(aDate[1])-1, aDate[2]);
    },
    edades() {
      let edades = {};
      for (let index = 1; index <= this.cantidad; index++) {
        edades[index] = this.calculateAge(this.nacimientos[index])
      }
      return edades;
    },
    afiliados() {
      let aData = [];
      for (let index = 1; index <= this.cantidad; index++) {
        const element = {
          "codigoCertificado": this.codigosCertificados[index] ?? '',
          "nombres": this.nombres[index],
          "apellidos": this.apellidos[index],
          "dob": this.nacimientos[index],
          "edad": this.edades[index],
          "documento": this.documentos[index],
          "telefono": this.telefonos[index],
          "email": this.emails[index],
        };
        aData.push(element);
      }
      return aData;
    },
    cotizacionValidada() {
      let isValid = true;
      if (!this.valueIsValid(this.programa)) { isValid = false; }
      if (!this.valueIsValid(this.periodicidad)) { isValid = false; }
      if (!this.valueIsValid(this.cantidad)) {
        isValid = false;
      } else {
        for (let index = 1; index <= this.cantidad; index++) {
          if (!this.valueIsValid(this.nacimientos[index])) { isValid = false; }
        }
      }
      return isValid;
    },
    validaPeticionPrograma() {
      let isValid = true;
      if (!this.valueIsValid(this.periodicidad)) { isValid = false; }
      if (!this.valueIsValid(this.cantidad)) {
        isValid = false;
      } else {
        for (let index = 1; index <= this.cantidad; index++) {
          if (!this.valueIsValid(this.nacimientos[index])) { isValid = false; }
        }
      }
      if (isValid) { this.getProgramas() }
      return isValid;
    },
    registroValido: function () {
      let isValid = true;
      this.afiliados.forEach((element, index) => {
        let n = index + 1;
        this.errorNombres[n] = false;
        this.errorApellidos[n] = false;
        this.errorDocumentos[n] = false;
        this.errorTelefonos[n] = false;
        this.errorEmails[n] = false;
        if (!this.valueIsValid(element.nombres)) {
          this.errorNombres[n] = true;
          isValid = false;
        }
        if (!this.valueIsValid(element.apellidos)) {
          isValid = false;
          this.errorApellidos[n] = true;
        }
        if (!this.valueIsValid(element.documento)) {
          isValid = false;
          this.errorDocumentos[n] = true;
        }
        if (!this.valueIsValid(element.telefono)) {
          isValid = false;
          this.errorTelefonos[n] = 'Campo Requerido';
        } else {
          if (!this.isPhoneNumberValid(element.telefono)) {
            isValid = false;
            this.errorTelefonos[n] = 'Teléfono Inválido';
          }
        }
        if (!this.valueIsValid(element.email)) {
          isValid = false;
          this.errorEmails[n] = 'Campo Requerido';
        } else if (!this.isEmailValid(element.email)) {
          isValid = false;
          this.errorEmails[n] = 'Email Inválido';
        }
      });
      return isValid;
    },
    compraValida: function () {
      let isValid = true;
      if (!this.valueIsValid(this.terminosCheck) || !this.terminosCheck) {
        isValid = false;
      }
      if (!this.valueIsValid(this.formaPago)) {
        isValid = false;
      }
      return isValid;
    },
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  watch: {
    programa(value) {
      this.tarifa = null;
      this.generarCodigoCertificado = null;
      this.getBeneficioCobertura();
      if (value) {
        const programSelected = this.allProgramas.find(({ id_programa }) => id_programa === value);
        this.tarifa = programSelected.tarifa;
        this.generarCodigoCertificado = programSelected.generar_codigo_certificado;
      }
    },
    periodicidad(newValue) {
      let date = new Date();
      let endDate = null;
      const periodSelected = this.periodicidadOptions.find(({ value }) => value === newValue);
      if (periodSelected) {
        date.setMonth(date.getMonth() + periodSelected.meses_cubiertos);
        endDate = new Date(date).toJSON().slice(0, 10)
      }
      this.vigencia.fin = endDate;
    }
  },
  mounted() {
    this.validateRoute();
    this.getPeriodos();
  }
};
</script>
<style scoped>
  #calendar-div {
    background-color: var(--bs-addiuva-purple) !important;
  }
  .vuejs3-datepicker__value{
    background-color: red !important;
  }
</style>